(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile menu functionality
  const hamburger = document.querySelector('.header__hamburger');
  const menuDrawer = document.querySelector('.header__nav-drawer');
  const menuOverlay = document.querySelector('.header__overlay');
  const closeBtn = document.querySelector('.header__nav-close');

  function openMenu() {
    menuDrawer.classList.add('active');
    menuOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    menuDrawer.classList.remove('active');
    menuOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);
  menuOverlay.addEventListener('click', closeMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Auto-detect light/dark theme based on background color
  function getContrastMode(hexColor) {
    // Remove # if present
    const hex = hexColor.replace('#', '');
    
    // Convert to RGB
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    
    // Calculate relative luminance using WCAG formula
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // Return 'dark' for light backgrounds, 'light' for dark backgrounds
    return luminance > 0.5 ? 'light' : 'dark';
  }

  // Apply theme to hero section
  const heroSection = document.querySelector('.product__hero[data-bg-color]');
  if (heroSection) {
    const bgColor = heroSection.getAttribute('data-bg-color');
    if (bgColor) {
      const theme = getContrastMode(bgColor);
      heroSection.setAttribute('data-theme', theme);
    }
  }

  // Quantity controls
  function updateQuantityButtons(input, decreaseBtn) {
    const value = parseInt(input.value);
    if (decreaseBtn) {
      decreaseBtn.disabled = value <= 1;
    }
  }

  document.querySelectorAll('[data-quantity-decrease]').forEach(button => {
    const input = button.parentElement.querySelector('.product__quantity-input');
    
    // Initial state
    updateQuantityButtons(input, button);
    
    button.addEventListener('click', () => {
      const currentValue = parseInt(input.value);
      if (currentValue > 1) {
        input.value = currentValue - 1;
        updateQuantityButtons(input, button);
      }
    });
  });

  document.querySelectorAll('[data-quantity-increase]').forEach(button => {
    const input = button.parentElement.querySelector('.product__quantity-input');
    const decreaseBtn = button.parentElement.querySelector('[data-quantity-decrease]');
    
    button.addEventListener('click', () => {
      const currentValue = parseInt(input.value);
      input.value = currentValue + 1;
      updateQuantityButtons(input, decreaseBtn);
    });
  });

  // Update button state when input changes directly
  document.querySelectorAll('.product__quantity-input').forEach(input => {
    const decreaseBtn = input.parentElement.querySelector('[data-quantity-decrease]');
    input.addEventListener('change', () => {
      updateQuantityButtons(input, decreaseBtn);
    });
  });

  // Image gallery carousel
  const gallery = document.querySelector('[data-image-gallery]');
  if (gallery) {
    const slides = gallery.querySelectorAll('.product__image-slide');
    const prevButton = document.querySelector('[data-image-prev]');
    const nextButton = document.querySelector('[data-image-next]');
    const counterElement = document.querySelector('[data-current-index]');
    let currentIndex = 0;

    function updateGallery() {
      // Update slides
      slides.forEach((slide, index) => {
        if (index === currentIndex) {
          slide.classList.add('product__image-slide--active');
        } else {
          slide.classList.remove('product__image-slide--active');
        }
      });

      // Update counter
      if (counterElement) {
        counterElement.textContent = currentIndex + 1;
      }

      // Update button states
      if (prevButton) {
        prevButton.disabled = currentIndex === 0;
      }
      if (nextButton) {
        nextButton.disabled = currentIndex === slides.length - 1;
      }
    }

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        if (currentIndex > 0) {
          currentIndex--;
          updateGallery();
        }
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        if (currentIndex < slides.length - 1) {
          currentIndex++;
          updateGallery();
        }
      });
    }

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft' && currentIndex > 0) {
        currentIndex--;
        updateGallery();
      } else if (e.key === 'ArrowRight' && currentIndex < slides.length - 1) {
        currentIndex++;
        updateGallery();
      }
    });

    // Touch swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    gallery.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });

    gallery.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    });

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0 && currentIndex < slides.length - 1) {
          // Swipe left - next image
          currentIndex++;
          updateGallery();
        } else if (diff < 0 && currentIndex > 0) {
          // Swipe right - previous image
          currentIndex--;
          updateGallery();
        }
      }
    }

    // Initial state
    updateGallery();
  }

  // Variant selection
  document.querySelectorAll('.product__variant-input').forEach(input => {
    input.addEventListener('change', (e) => {
      const variantId = e.target.value;
      // Update URL with variant parameter
      const url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    });
  });

  // Add to cart form submission
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const submitButton = productForm.querySelector('.product__add-to-cart');
      const originalButtonText = submitButton.textContent;
      
      // Disable button and show loading state
      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';
      
      try {
        const formData = new FormData(productForm);
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity'))
          })
        });
        
        if (response.ok) {
          const data = await response.json();
          
          // Show success state briefly
          submitButton.textContent = 'Added!';
          
          // Trigger custom event to open cart drawer
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { open: true, item: data }
          }));
          
          // Reset button after short delay
          setTimeout(() => {
            submitButton.disabled = false;
            submitButton.textContent = originalButtonText;
          }, 1000);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        submitButton.textContent = 'Error - Try again';
        setTimeout(() => {
          submitButton.disabled = false;
          submitButton.textContent = originalButtonText;
        }, 2000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
